var editFuelDispenser = (function () {
    const init = function () {
        $('#fuel-dispenser-fuel-cards-datatable').DataTable({
            "autoWidth": false,
            "pageLength": 10,
            "order": [],
            "columnDefs": [
                { "orderable": false, "targets": 0 },
                { "orderable": false, "targets": 1 },

                { "className": 'numerationColumn', "targets": 0 },
                { "className": 'serialNumberColumn', "targets": 1 }
            ],
            language: {
                url: 'https://cdn.datatables.net/plug-ins/1.10.19/i18n/Ukrainian.json'
                //TODO: make it depends on current culture not on sdn call
            }
        });

    };

    $('.remove-component-button').each(function () {
        $(this).on('click',
            function () {
                $(this).parent().remove();
            });
    });

    $('#edit-pump-button').on('click',
        function () {
            const $dropdownList = $(this).parents('.dropdown-list');
            $dropdownList.append(buildAdditionalDropdown($dropdownList));
        });

    $('#edit-filter-button').on('click',
        function () {
            const $dropdownList = $(this).parents('.dropdown-list');
            $dropdownList.append(buildAdditionalDropdown($dropdownList));
        });

    $('#edit-meter-button').on('click',
        function () {
            const $dropdownList = $(this).parents('.dropdown-list');
            $dropdownList.append(buildAdditionalDropdown($dropdownList));
        });

    $('#edit-nozzle-button').on('click',
        function () {
            const $dropdownList = $(this).parents('.dropdown-list');
            $dropdownList.append(buildAdditionalDropdown($dropdownList));
        });

    $('#edit-dischargeKit-button').on('click',
        function () {
            const $dropdownList = $(this).parents('.dropdown-list');
            $dropdownList.append(buildAdditionalDropdown($dropdownList));
        });

    $('#edit-suctionKit-button').on('click',
        function () {
            const $dropdownList = $(this).parents('.dropdown-list');
            $dropdownList.append(buildAdditionalDropdown($dropdownList));
        });


    function buildAdditionalDropdown($dropdownList) {
        const $additionalDropdown = $('<div class="additional-dropdown"></div>')
            .append($dropdownList.find('.dropdown select').clone());

        const $removeIcon = $('<i class="mdi mdi-close-circle-outline remove-component-button"></i>').on('click',
            function () {
                $(this).parent().remove();
            });

        $additionalDropdown.find('select').after($removeIcon);
        return $additionalDropdown;
    }


    $('#edit-fuel-dispenser-button').on('click',
        function () {
            if (validate() === false) {
                return;
            }

            const editViewModel = {
                Id: $('#fuel-dispenser-id').val(),
                FuelDispenserDetailsViewModel: {
                    SerialNumber: $('#SerialNumber').val(),
                    State: $('#State').val(),
                    ActivationCode: $('#ActivationCode').val(),
                    ApiKey: $('#ApiKey').val(),
                    ResponseTimeInDays: $('#ResponseTimeInDays').val(),
                    Comment: $('#Comment').val(),
                    SelectedHardwareId: $('.hardware-dropdown').val(),
                    SelectedBootloaderId: $('.bootloader-dropdown').val(),
                    SelectedFirmwareId: $('.firmware-dropdown').val()
                },

                SelectedIqModelId: $('.fuel-dispenser-model-dropdown').val(),
                SelectedPumpIds: selectValues($('.pump-dropdown')),
                SelectedMeterIds: selectValues($('.meter-dropdown')),
                SelectedFilterIds: selectValues($('.filter-dropdown')),
                SelectedNozzleIds: selectValues($('.nozzle-dropdown')),
                SelectedDischargeKitIds: selectValues($('.discharge-kit-dropdown')),
                SelectedSuctionKitIds: selectValues($('.suction-kit-dropdown'))
            };

            $.ajax({
                url: '/FuelDispensers/Edit',
                method: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(editViewModel)
            })
                .done(function (data) {
                    if (data.success) {
                        $.notificationSuccess(data.header, data.message);
                        setTimeout(function () {
                            document.location = '/FuelDispensers/Index';
                        }, reloadDelay);
                    } else {
                        showServerValidation(data.validationErrors);
                    }
                });


            function validate() {
                var isValid = true;
                $('.validation').hide();
                if (!hasValue($('#SerialNumber'))) {
                    $('#SerialNumberValidation').show();
                    isValid = false;
                }
                if (!hasValue($('#ActivationCode'))) {
                    $('#ActivationCodeValidation').show();
                    isValid = false;
                }
                if (hasValue($('#ResponseTimeInDays'))) {
                    if ($('#ResponseTimeInDays').val() <= 0) {
                        $('#WrongResponseTimeInDays').show();
                        isValid = false;
                    }
                } else {
                    $('#ResponseTimeInDaysValidation').show();
                    isValid = false;
                }

                return isValid;
            }

            function hasValue($field) {
                return $field.val()
                    ? $field.val().length !== 0
                    : false;
            }

            function showServerValidation(response) {
                for (let fieldValue in response) {
                    if (response.hasOwnProperty(fieldValue)) {
                        if (response[fieldValue] === true) {
                            $(`#${fieldValue.toString()}`).show();
                        }
                    }
                }
            }
        });

    function selectValues($inputs) {
        var values = [];
        $inputs.each(function () {
            const value = $(this).val();
            if (value) {
                values.push(value);
            }
        });
        return values;
    }



    return {
        init: init
    };

})();
